import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';

class SubmitUpgradeOrgRequestModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgJoinResponseMessage: ""
		};
	}

	componentDidMount() {

	}

	handleConfirm = (event) => {
		this.props.submitUpgradeRequest();
	}

	handleCancel = (event) => {
		this.props.hideSubmitUpgradeOrgRequestModal();
	}

	render () {

		return (
			<Modal onHide={this.props.hideSubmitUpgradeOrgRequestModal} show={this.props.showSubmitUpgradeOrgRequestModal} aria-labelledby="ModalHeader">
            	<Modal.Header closeButton>
              		<Modal.Title id='ModalHeader'>Submit Organization/Company Information</Modal.Title>
            	</Modal.Header>
            	<Modal.Body>
					NOTE: Your organization/company information will be used to complete your personal address information if those fields
					have not been provided. To update personal information at any time, please go to Manage My Account > Account
					Settings screen.
            	</Modal.Body>
            	<Modal.Footer>
              		<button className='button secondary light-bg' onClick={this.handleConfirm} name="Confirm">
                		Confirm
              		</button>  
					  <button className='button secondary light-bg' onClick={this.handleCancel} name="Cancel">
                		Cancel
              		</button>          		
            	</Modal.Footer>
          </Modal>
		)
	}
}

export default SubmitUpgradeOrgRequestModal;



// WEBPACK FOOTER //
// ./src/manageOrg/SubmitUpgradeOrgRequestModal.js